enum ECookies {
    PLUS_WCAG1 = 'plusWCAG1',
    USER_ID = 'user_id',
    TOKEN = 'apollo_tb2c_auth',
    EUMOWA_COMPONENT = 'e_umowa_component',
    GDPRC = 'gdprc',
    PASSWORD = 'password',
    PROMETHEUS_TOKEN = 'prometheus_tb2c_auth',
}

export default ECookies
